import {Component} from "@angular/core";
import {ActivatedRoute, Router, RouterModule} from '@angular/router';
import { HttpClient } from "@angular/common/http";
import {WebmateOptions} from "@webmate-web-core/webmate-options";

import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {ButtonModule} from 'primeng/button';

@Component({
    selector: 'wm-mobileaccess-activation',
    styleUrls: ['./mobileaccess-activation.component.less'],
    templateUrl: './mobileaccess-activation.component.html',
    standalone: true,
    imports: [RouterModule, FontAwesomeModule, ButtonModule]
})
export class MobileAccessActivationComponent {
    constructor(private route: ActivatedRoute, private router: Router, private webmateOptions: WebmateOptions,
                private http: HttpClient) {}

    activationId?: string;
    tokenId?: string;
    customerId?: string;

    ngOnInit() {
        this.route.queryParamMap.subscribe(paramMap => {
            this.customerId = paramMap.get('customerId') ?? undefined;
            this.activationId = paramMap.get('activationId') ?? undefined;
            this.tokenId = paramMap.get('tokenId') ?? undefined;
        });
    }

    activateToken(event: MouseEvent) {
        const body = {
            activationId: this.activationId
        };
        // call is unauthenticated. interceptor won't add base uri
        this.http.post(`/device/mobileaccesstokens/${this.tokenId}`, body, {responseType: 'blob'}).subscribe(configBlob => {
            let url = window.URL.createObjectURL(configBlob);
            //append fake element and click it to trigger the download
            let a = document.createElement('a');
            document.body.appendChild(a);
            a.setAttribute('style', 'display: none');
            a.href = url;
            a.download = 'webmate.ovpn';
            a.click();
            window.URL.revokeObjectURL(url);
            a.remove();
        });
    }
}
